<template>
    <InlineSvg v-if="iconSrc" :src="iconSrc" :width="width" :height="height" :aria-label="ariaLabel"></InlineSvg>
</template>

<script setup lang="ts">
import InlineSvg from 'vue-inline-svg';
import { computed } from 'vue';
import icons from './icons';

export interface Props {
    name: string;
    width?: number;
    height?: number;
    ariaLabel?: string;
}

const props = defineProps<Props>();

const iconSrc = computed<string>(() => {
    if (props.name in icons) {
        return icons[props.name];
    }

    return '';
});
</script>

<style lang="scss">
.dhf-svg-icon {
    display: inline-flex;
}
</style>
